import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const LeftImgrightContent = ({leftImgContent})=>{
    return(
        <>
           <Container className="my-3">
            
                <Row className="" id="borderForMobile">
                    <Col md={7} className="p-0 m-0">
                        <img className="rounded-5 img-fluid" loading="lazy" src={leftImgContent.leftImg} id="internalpageBanner"/>
                    </Col>
                    <Col md={5} className="rounded-5 bgeYantra py-4 px-4" id="contentMobileBorder" style={{backgroundImage:'url(./assests/images/internalpages/circles.svg)',
                            backgroundPosition: 'right bottom',
                            backgroundSize: 'auto',
                            backgroundRepeat: 'no-repeat',
                    }}>

                        <h2 className="fs-48 fs-m-big">{leftImgContent.leftHeading}</h2>
                        <p className="fst-italic fw-normal fw-md-normal fs-20 fs-m-subHeading">{leftImgContent.leftSmallpara}</p>
                        <p className="fs-6 fs-md-5 fw-lighter">
                            {leftImgContent.leftParagraph}
                        </p>

                        
                            <Link className="text-white text-decoration-none" to={leftImgContent.leftRedirectUrl}>
                            <Button id="btnCTA" className="fw-light rounded-5 px-5">Learn More
                            </Button>
                            </Link>
                        

                        
                    </Col>
                </Row>
           </Container>
           

        
        </>
    )
}
export default LeftImgrightContent;